import { Widgets } from "./Widgets"

export class DeviceImage extends Widgets {
    constructor(selector) {
        super(selector);

        this.wrappDeviceImage(this.element.querySelector(".image"));
    }
}       